module.exports = __webpack_public_path__ + "03_short_gold.fea8c8ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/03_short_gold.png
// module id = J6pL
// module chunks = 0